<template>
    <div>
        <table-title>归还订单详情</table-title>
        <Form :model="formData" ref="formValidates" :label-width="130" inline>
            <FormItem label="归还预约单号">
                <Input v-model="paramsData" disabled style="width: 180px" />
            </FormItem>
            <FormItem label="租借人">
                <Input v-model="formData.leaseeId" disabled style="width: 180px" />
            </FormItem>
            <FormItem label="标的物小类">
                <Input v-model="formData.targetType" disabled style="width: 180px" />
            </FormItem>
            <br />
            <FormItem label="租借方联系人">
                <Input v-model="formData.contactId" disabled style="width: 180px" />
            </FormItem>
            <FormItem label="预约归还总数">
                <Input v-model="formData.totalAmount" disabled style="width: 180px" />
            </FormItem>
            <FormItem label="回收数量">
                <Input v-model="formData.recycledAmount" disabled style="width: 180px" />
            </FormItem>
            <br />
             <FormItem label="仓库名称">
                <Input v-model="formData.storageId" disabled style="width: 180px" />
            </FormItem>
            <FormItem label="回收方式">
                <Input v-model="formData.recycleMethod" disabled style="width: 180px" />
            </FormItem>
            <FormItem label="可交付日期">
                <Input v-model="formData.expectedBillingUntil" disabled style="width: 180px" />
            </FormItem><br>
            <FormItem label="预约确认说明">
                <Input type="textarea" v-model="formData.recycleAppointmentAckComment" disabled style="width: 500px" />
            </FormItem>
             <FormItem label="责任分区">
                <Input v-model="formData.groupFlag" disabled style="width: 180px" />
            </FormItem>
        </Form>
        <div style="text-align:center">
            <Button type="warning" style="margin-left:5px" @click="goBlack">返回</Button>
        </div>

    </div>
</template>

<script>
import dictSelect from '@/components/select/dict-select.vue'
import tableTitle from "@/components/tableTitle/tableTitle"
export default {
    components: { tableTitle, dictSelect },
    props: ['paramsData'],
    data() {
        return {
            formData: {
                leaseeId: "",
                targetType: "",
                contactId: "",
                totalAmount: "",
                recycledAmount: "",
                recycleMethod: "",
                storageId:"",
                expectedBillingUntil: "",
                recycleAppointmentAckComment:""
            }
        }
    },
    async created(){
        await this.dict.initDict([{ id: 'respZone', namespace: 'bizObjects' },{ id: 'contact', namespace: 'bizObjects', }, { id: 'warehouse', namespace: 'bizObjects', }]); // 初始化字典
    },
    mounted() {
        this.getDetail()
    },
    methods: {
        goBlack(){
            this.$emit("onFinish")
        },
        getDetail() {
            let data = {
                url: "MID-OPERATE-LEASE/messageService/recycleService/queryRecycleAppointmentById",
                body: { id: this.paramsData }
            }
            this.invoke(data).then(res => {
                this.formData.recycleMethod = this.$options.filters['queryDict']('ENUM_MID-OPERATE-LEASE', 'recycleAppointment.RecycleMethod', res.recycleMethod);
                this.formData.leaseeId = this.$options.filters['queryDict']('bizObjects', 'member', res.leaseeId)
                this.formData.targetType = this.$options.filters['queryDict']('target', 'type', res.targetType)
                this.formData.contactId = this.$options.filters['queryDict']('bizObjects', 'contact', res.contactId)
                this.formData.storageId =res.storageId?this.$options.filters['queryDict']('bizObjects','warehouse',res.storageId):''
                this.formData.totalAmount = res.totalAmount
                this.formData.recycledAmount = res.recycledAmount
                this.formData.expectedBillingUntil = res.expectedBillingUntil ? new Date(res.expectedBillingUntil).Format("yyyy-MM-dd") : "";
                this.formData.recycleAppointmentAckComment = res.recycleAppointmentAckComment
                this.formData.groupFlag =res.groupFlag?this.$options.filters['queryDict']('bizObjects', 'respZone', res.groupFlag) :"";

            })
        }
    }

}
</script>